/*
 * MARKUP INSIDE A TRANSLATED SENTENCE.
 *
 * A sentence like "went to <b>Overloaded</b> and <b>Alarm</b>" cannot be built
 * by gluing bold words around translated fragments — the words either side,
 * and the "and", belong to the locale. So the sentence is translated whole with
 * a placeholder where the markup goes, and split around it; a list is
 * formatted by Intl.ListFormat over placeholders and each is swapped back for
 * its template.
 */
import { html } from 'lit';
import { getLocale } from './index';
/** The placeholder to pass as an interpolation value where `withSlot` fills in
 *  markup. A NUL, so it can never collide with translated text. */
export const SLOT = String.fromCharCode(0);
/** A translated sentence with its one SLOT filled by a template. */
export function withSlot(text, tpl) {
    const at = text.indexOf(SLOT);
    if (at < 0)
        return html `${text}`;
    return html `${text.slice(0, at)}${tpl}${text.slice(at + SLOT.length)}`;
}
const lfCache = new Map();
function listFormat(type) {
    const key = `${getLocale()}|${type}`;
    let lf = lfCache.get(key);
    if (!lf) {
        lf = new Intl.ListFormat(getLocale(), { type });
        lfCache.set(key, lf);
    }
    return lf;
}
/** Plain strings as the locale lists them: "a, b and c" / "a, b or c". */
export function formatList(items, type = 'conjunction') {
    return listFormat(type).format(items);
}
/** `formatList` over templates, so a list can carry bold without losing the
 *  locale's own separators. */
export function listOf(items, type = 'conjunction') {
    const parts = listFormat(type).formatToParts(items.map((_, i) => String(i)));
    return html `${parts.map((p) => (p.type === 'element' ? items[Number(p.value)] : p.value))}`;
}
//# sourceMappingURL=rich.js.map